import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import * as React from 'react';
import { useBoundingClientRect } from '../../hooks';
import { ClassNames } from '../../utils/classNames';
/** A div which will automatically resize depending on the size of its children */

export var AutoResizer = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      children = _a.children,
      style = _a.style,
      onSizeChange = _a.onSizeChange,
      resizeHorizontal = _a.resizeHorizontal,
      resizeVertical = _a.resizeVertical,
      nativeProps = __rest(_a, ["className", "children", "style", "onSizeChange", "resizeHorizontal", "resizeVertical"]);

  var contentRef = React.useRef(null);
  var onChange = React.useCallback(function (rect) {
    onSizeChange === null || onSizeChange === void 0 ? void 0 : onSizeChange({
      width: rect.width,
      height: rect.height
    });
  }, [onSizeChange]);

  var _useBoundingClientRec = useBoundingClientRect(contentRef, onChange, false),
      _useBoundingClientRec2 = _slicedToArray(_useBoundingClientRec, 1),
      _useBoundingClientRec3 = _useBoundingClientRec2[0],
      height = _useBoundingClientRec3.height,
      width = _useBoundingClientRec3.width;

  return React.createElement("div", Object.assign({}, nativeProps, {
    className: ClassNames.concat('arm-auto-resizer', className),
    style: Object.assign(Object.assign(Object.assign({}, resizeHorizontal ? {
      '--arm-auto-resizer-width': "".concat(width, "px")
    } : {}), resizeVertical ? {
      '--arm-auto-resizer-height': "".concat(height, "px")
    } : {}), style || {}),
    "data-animate-horizontal": resizeHorizontal,
    "data-animate-vertical": resizeVertical,
    ref: ref
  }), React.createElement("div", {
    ref: contentRef,
    className: "arm-auto-resizer-content"
  }, children));
});
AutoResizer.defaultProps = {
  resizeVertical: true,
  resizeHorizontal: true
};